'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'cloud';
var width = 576;
var height = 512;
var aliases = [9729];
var unicode = 'f0c2';
var svgPathData = ['M48 336l0 96 480 0 0-80c0-33.2-20.3-61.8-49.2-73.9l-14.8-6.2 0-72c0-39.8-32.2-72-72-72-11.1 0-21.5 2.5-30.8 6.9l-18.2 8.6-11.7-16.4C311 98.6 277.7 80 240 80 178.1 80 128 130.1 128 192l0 47.8-16 5.7C74.7 258.6 48 294.2 48 336z', 'M80 192c0-88.4 71.6-160 160-160 47.1 0 89.4 20.4 118.7 52.7 10.6-3.1 21.8-4.7 33.3-4.7 66.3 0 120 53.7 120 120l0 41.1c38.2 22.1 64 63.5 64 110.9l0 128-576 0 0-144c0-56.6 32.6-105.5 80-129l0-15zM240 80c-61.9 0-112 50.1-112 112l0 47.8-16 5.7C74.7 258.6 48 294.2 48 336l0 96 480 0 0-80c0-33.2-20.3-61.8-49.2-73.9l-14.8-6.2 0-72c0-39.8-32.2-72-72-72-11.1 0-21.5 2.5-30.8 6.9l-18.2 8.6-11.7-16.4C311 98.6 277.7 80 240 80z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloud = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;